import React from 'react'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { useServerConfig } from '@core/Data/ServerConfig/useServerConfig'

export const VersionInfo = () => {
  const config = useServerConfig()
  const versionInfo = window?.TABTOUCH?.versionInfo
  const serverVersion = config ? `${config.serverVersion} (${config.serverEnvironment})` : 'Unknown'

  return (
    <>
      <h3>Version Details</h3>
      <dl className='fz-14 pl1em'>
        <dt>Server Version</dt>
        <dd className='ml1em'>{serverVersion}</dd>
        <dt>Client Version (from bundle)</dt>
        <dd className='ml1em'>{fullClientVersion}</dd>
      </dl>

      {versionInfo && <IndexInfo versionInfo={versionInfo} />}
    </>
  )
}

const IndexInfo = ({ versionInfo }: { versionInfo: VersionInfo }) => (
  <>
    <h3>Index Details</h3>
    <dl className='fz-14 pl1em'>
      <dt>Client Version</dt>
      <dd className='ml1em'>{versionInfo.version}</dd>
      <dt>Git Commit SHA</dt>
      <dd className='ml1em'>{versionInfo.gitCommitShaShort}</dd>
      <dt>User</dt>
      <dd className='ml1em'>{versionInfo.gitUsername}</dd>
      <dt>Git Pipeline</dt>
      <dd className='ml1em'>
        <a href={versionInfo.gitPipelineUrl} target='_blank' rel='noreferrer'>
          {versionInfo.gitPipelineIid}
        </a>
      </dd>
      <dt>GitLab Project</dt>
      <dd className='ml1em'>
        <a href={versionInfo.gitProjectUrl} target='_blank' rel='noreferrer'>
          {versionInfo.gitProjectUrl}
        </a>
      </dd>
    </dl>
  </>
)
